import { WEEKDAYS } from 'constants/dates';

import { useBusiness } from 'hooks/business/useBusiness';

import { getFormattedBusinessHours } from 'utils/getFormattedBusinessHours';

import s from './CanvasBusinessHours.module.css';

const CanvasBusinessHours = () => {
  const { businessHours } = useBusiness();

  return (
    <section className={s.businessHours}>
      {businessHours && (
        <div className={s.hoursContainer}>
          <h3 className={s.hoursTitle}>HOURS AND LOCATION</h3>
          {WEEKDAYS.map((name) => {
            const { start, end, working } = businessHours[name.toLowerCase()];

            if (working) {
              return (
                <div className={s.dayHours} key={name}>
                  <p>{name.toUpperCase()}</p>
                  <p>
                    {getFormattedBusinessHours(start)} -{' '}
                    {getFormattedBusinessHours(end)}
                  </p>
                </div>
              );
            }
            return (
              <div className={s.dayHours} key={name}>
                <p>{name}</p>
                <p>Closed</p>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export { CanvasBusinessHours };
